import React, { useEffect }  from "react";
import { Box, Typography }   from "@mui/material";
import { useTheme }          from "@mui/material/styles";
import { useNavigate }       from "react-router-dom";

import RoleCardGrid      from "./components/RoleCardGrid";
import LoginFooter       from "./components/LoginFooter";
import LoginError        from "./components/LoginError";
import WordMark          from "../../../components/common/WordMark";
import ThemeToggleButton from "../../../components/common/ThemeToggleButton";

import useAuth                 from "../../../hooks/useAuth";
import { setPageTitle }        from "../../../utils/document";
import { ROLE_DEFAULT_ROUTES } from "../../../constants/auth";
import { setPostLoginRoute, consumePostLoginRoute } from "../../../constants/auth/postLoginRoute";
import AuthLoader from "../../../components/common/AuthLoader";

const LoginPage = () => {
  const theme    = useTheme();
  const t        = theme.custom;
  const navigate = useNavigate();

  const {
    login,
    isAuthenticated,
    userRole,
    loading,
    authError,
    clearAuthError,
  } = useAuth();

  useEffect(() => {
    const selectedCardId = localStorage.getItem("selectedCardId");
    if (selectedCardId === "INVESTMENT_LEAGUE" && isAuthenticated) {
      navigate("/investment-league", { replace: true });
      return;
    }
   else {
    setPageTitle("Login");
   }
  
  }, []);

  useEffect(() => {
    if (isAuthenticated && userRole) {
      const storedRoute = consumePostLoginRoute();
      const returnTo = sessionStorage.getItem("psi360_return_to");
      sessionStorage.removeItem("psi360_return_to");
      const checkRoute = localStorage.getItem("selectedCardId");
      const route = storedRoute || returnTo || (checkRoute === "INVESTMENT_LEAGUE" ? "/investment-league" : ROLE_DEFAULT_ROUTES[userRole] || "/dashboard");
      navigate(route, { replace: true });
    }
  }, [isAuthenticated, userRole, navigate]);

  const handleAppLogin = (cardId) => {
    localStorage.setItem("selectedCardId", cardId);
    if (cardId === "INVESTMENT_LEAGUE") {
      if (isAuthenticated) {
        navigate("/investment-league", { replace: true });
        return;
      }
      setPostLoginRoute("/investment-league");
    }
    login();
  };
  const handleAdminLogin = () => login();

if (loading) return <AuthLoader role={userRole} />;

  return (
    <Box
      sx={{
        minHeight:      "100vh",
        background:     t.bg,
        display:        "flex",
        flexDirection:  "column",
        alignItems:     "center",
        justifyContent: "center",
        padding:        "40px 20px",
        position:       "relative",
      }}
    >
      {/* Theme toggle - fixed top right */}
      <Box sx={{ position: "absolute", top: "20px", right: "20px" }}>
        <ThemeToggleButton />
      </Box>

      {/* PSI360 wordmark */}
      <WordMark size="44px" />

      {/* Platform subtitle */}
      <Typography
        sx={{
          fontFamily:    "'Inter', 'Courier New', monospace",
          fontSize:      "10px",
          letterSpacing: "0.28em",
          textTransform: "uppercase",
          color:         t.text3,
          mt:            "4px",
          mb:            "40px",
        }}
      >
        Resource Allocation Platform
      </Typography>

      {/* Inline error */}
      {authError && (
        <Box sx={{ mb: "24px", width: "860px", maxWidth: "100%" }}>
          <LoginError
            message={authError}
            onClose={clearAuthError}
          />
        </Box>
      )}

      {/* Three application cards */}
      <Box sx={{ mb: "48px" }}>
        <RoleCardGrid onCardClick={handleAppLogin} />
      </Box>

      {/* Footer with hidden admin link */}
      <LoginFooter onAdminClick={handleAdminLogin} />
    </Box>
  );
};

export default LoginPage;